export default {
  breakpoints: {
    xs: 0,
    sm: 375,
    md: 768,
    lg: 1170,
    xl: 1440
  }
}



// WEBPACK FOOTER //
// ./src/assets/js/config.js